export const LoadingAnimationURL = "https://cdn.shopify.com/s/files/1/0496/8733/0976/files/Loading_Animation.gif?v=1775111275";
export const BattleKartLoadingGifURL = "https://cdn.shopify.com/s/files/1/0496/8733/0976/files/Loading_Screen.gif?v=1773794204";
export const MainTrack11To14Video = "https://cdn.shopify.com/videos/c/o/v/2b8204d2f7da429e8f33a234c0b46e44.mp4";
